import { useEffect, useState } from "react";
import FilterByField from "./filterByField";
import { getObject, getQueryData } from "../../services/apiService";

function FilterByIdInsideCrossFilter({
  title,
  index,
  filters,
  crossFilters,
  setCrossFilters,
}) {
  const [filterFields, setFilterFields] = useState([]);
  useEffect(() => {
    // console.log("title", title);
    if (title) fetchFilterFields(title);
  }, [title]);

  const fetchFilterFields = async (objectName) => {
    let { data: obejctDetails } = await getObject(objectName);
    // console.log("object Detials", obejctDetails);
    setFilterFields(obejctDetails.fields);
  };
  const handleUpdateFilters = (data, index) => {
    // console.log("changing...", data);
    let tempCrossFilters = JSON.parse(JSON.stringify(crossFilters));
    tempCrossFilters[index].filters = data;
    setCrossFilters([...tempCrossFilters]);
  };

  return (
    <>
      <FilterByField
        title={title}
        filters={filters}
        filterFields={filterFields}
        setFilters={(data) => {
          handleUpdateFilters(data, index);
        }}
      />
    </>
  );
}

export default FilterByIdInsideCrossFilter;
